import React from "react";
import { useSelector } from "react-redux";
import WizardSteps from "./WizardSteps";
import WizardNavigation from "./WizardNavigation";
import ProjectPreview from "../preview/ProjectPreview";

const ProjectWizard = () => {
  const isCreating = useSelector((state) => state.navigation.isCreating);
  // Note: isPreviewMode should be added to navigation slice if needed
  // For now, defaulting to false - update navigation slice if required
  const isPreviewMode = false;

  return (
    <div className="h-[calc(100vh-120px)] overflow-hidden">
      <div className="max-w-[120rem] mx-auto px-4 sm:px-6 lg:px-8 py-8 h-full flex flex-col">
        <div
          className={`grid grid-cols-1 ${
            isPreviewMode ? "lg:grid-cols-10" : ""
          } gap-8 flex-1 min-h-0 items-stretch`}
        >
          {/* Main Wizard Content - wider layout when creating for better use of screen space */}
          <div
            className={`${
              isPreviewMode
                ? "lg:col-span-3"
                : isCreating
                  ? "w-full max-w-7xl mx-auto"
                  : "w-full"
            } flex flex-col min-h-0`}
          >
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 flex-1 flex flex-col min-h-0 overflow-hidden">
              <WizardSteps />
              {isCreating && <WizardNavigation />}
            </div>
          </div>

          {/* Preview Panel */}
          {isPreviewMode && (
            <div className="lg:col-span-7">
              <ProjectPreview />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectWizard;
